export class Other {
    public GoLiveDate:string;
    public Note: string;
    public StartGibProcess:boolean;
}
